'use client'

import { PlusSquareOutlined24 } from '@vinted/monochrome-icons'
import { Button, Icon } from '@vinted/web-ui'

import { StartBundleButtonWrapper } from '@marketplace-web/bundles/items-bundle-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  addMoreItemsUrl: string | null
}

const AddMoreItems = ({ addMoreItemsUrl }: Props) => {
  const translate = useTranslate('conversation.composer')

  if (!addMoreItemsUrl) return null

  return (
    <StartBundleButtonWrapper url={addMoreItemsUrl} screen="message_reply">
      {({ onClick }) => (
        <Button
          inline
          theme="muted"
          styling={Button.Styling.Flat}
          size={Button.Size.Small}
          icon={<Icon name={PlusSquareOutlined24} color={Icon.Color.GreyscaleLevel3} />}
          testId="add-more-items-button"
          aria={{
            'aria-label': translate('a11y.actions.add_more_items'),
          }}
          onClick={onClick}
        />
      )}
    </StartBundleButtonWrapper>
  )
}

export default AddMoreItems
